import { Action } from '@ngrx/store';
import { Product } from '../models/product.model';


export enum ProductTypeAction{
    SAVE_PRODUCT="[Product] Save"
}

export class SaveProductAction implements Action{
    readonly type=ProductTypeAction.SAVE_PRODUCT;
    constructor(public payload:any){}
}

export type CrudProductAction = SaveProductAction;